import { render, staticRenderFns } from "./AddQuestionnaire.vue?vue&type=template&id=6fd5dfb3&scoped=true&"
import script from "./AddQuestionnaire.vue?vue&type=script&lang=js&"
export * from "./AddQuestionnaire.vue?vue&type=script&lang=js&"
import style0 from "./AddQuestionnaire.vue?vue&type=style&index=0&id=6fd5dfb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd5dfb3",
  null
  
)

export default component.exports